import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the Conge Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */
  static targets = ["hm0_output"];
  connect() {
    super.connect();
    console.log("NOTE DE FRAIS LOAD");
    if (
      $("#partial-content").length &&
      $("#partial-content").text().trim() == "Chargement en cours ..."
    ) {
      //on est sur le show
      setTimeout(() => this.note_de_frais_hm_ajax(), 300);
      //this.note_de_frais_hm_ajax();
    }
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });

      $("#filterrific_annee").click(function () {
        if ($(this).is(":checked")) {
          $(".annee").show();
        } else {
          $(".annee").hide();
        }
      });

      if ($("#filterrific_annee").is(":checked")) {
        $(".annee").show();
      } else {
        $(".annee").hide();
      }

      $("#filterrific_liste_moi").click(function () {
        if ($(this).is(":checked")) {
          $(".liste_moi").show();
        } else {
          $(".liste_moi").hide();
        }
      });

      if ($("#filterrific_liste_moi").is(":checked")) {
        $(".liste_moi").show();
      } else {
        $(".liste_moi").hide();
      }

      $("#filterrific_entite").click(function () {
        if ($(this).is(":checked")) {
          $(".entite").show();
        } else {
          $(".entite").hide();
        }
      });
      if ($("#filterrific_entite").is(":checked")) {
        $(".entite").show();
      } else {
        $(".entite").hide();
      }
      $("#filterrific_devise").click(function () {
        if ($(this).is(":checked")) {
          $(".devise").show();
        } else {
          $(".devise").hide();
        }
      });

      if ($("#filterrific_devise").is(":checked")) {
        $(".devise").show();
      } else {
        $(".devise").hide();
      }
      $("#filterrific_total_tva_devise_entite").click(function () {
        if ($(this).is(":checked")) {
          $(".total_tva_devise_entite").show();
        } else {
          $(".total_tva_devise_entite").hide();
        }
      });
      if ($("#filterrific_total_tva_devise_entite").is(":checked")) {
        $(".total_tva_devise_entite").show();
      } else {
        $(".total_tva_devise_entite").hide();
      }
      $("#filterrific_total_ttc_devise_entite").click(function () {
        if ($(this).is(":checked")) {
          $(".total_ttc_devise_entite").show();
        } else {
          $(".total_ttc_devise_entite").hide();
        }
      });
      if ($("#filterrific_total_ttc_devise_entite").is(":checked")) {
        $(".total_ttc_devise_entite").show();
      } else {
        $(".total_ttc_devise_entite").hide();
      }
      $("#filterrific_total_ht_devise_entite").click(function () {
        if ($(this).is(":checked")) {
          $(".total_ht_devise_entite").show();
        } else {
          $(".total_ht_devise_entite").hide();
        }
      });
      if ($("#filterrific_total_ht_devise_entite").is(":checked")) {
        $(".total_ht_devise_entite").show();
      } else {
        $(".total_ht_devise_entite").hide();
      }
      $("#filterrific_total_tva_devise_groupe").click(function () {
        if ($(this).is(":checked")) {
          $(".total_tva_devise_groupe").show();
        } else {
          $(".total_tva_devise_groupe").hide();
        }
      });
      if ($("#filterrific_total_tva_devise_groupe").is(":checked")) {
        $(".total_tva_devise_groupe").show();
      } else {
        $(".total_tva_devise_groupe").hide();
      }
      $("#filterrific_total_ttc_devise_groupe").click(function () {
        if ($(this).is(":checked")) {
          $(".total_ttc_devise_groupe").show();
        } else {
          $(".total_ttc_devise_groupe").hide();
        }
      });
      if ($("#filterrific_total_ttc_devise_groupe").is(":checked")) {
        $(".total_ttc_devise_groupe").show();
      } else {
        $(".total_ttc_devise_groupe").hide();
      }

      $("#filterrific_total_ht_devise_groupe").click(function () {
        if ($(this).is(":checked")) {
          $(".total_ht_devise_groupe").show();
        } else {
          $(".total_ht_devise_groupe").hide();
        }
      });
      $("#filterrific_total_ht_refacturable_devise_groupe").click(function () {
        if ($(this).is(":checked")) {
          $(".total_ht_refacturable_devise_groupe").show();
        } else {
          $(".total_ht_refacturable_devise_groupe").hide();
        }
      });
      $("#filterrific_total_ht_refacturable_devise_entite").click(function () {
        if ($(this).is(":checked")) {
          $(".total_ht_refacturable_devise_entite").show();
        } else {
          $(".total_ht_refacturable_devise_entite").hide();
        }
      });

      $("#filterrific_total_a_rembourser_devise_groupe").click(function () {
        if ($(this).is(":checked")) {
          $(".total_a_rembourser_devise_groupe").show();
        } else {
          $(".total_a_rembourser_devise_groupe").hide();
        }
      });

      $("#filterrific_total_a_rembourser_devise_entite").click(function () {
        if ($(this).is(":checked")) {
          $(".total_a_rembourser_devise_entite").show();
        } else {
          $(".total_a_rembourser_devise_entite").hide();
        }
      });

      if ($("#filterrific_total_ht_devise_groupe").is(":checked")) {
        $(".total_ht_devise_groupe").show();
      } else {
        $(".total_ht_devise_groupe").hide();
      }

      if ($("#filterrific_cree_le").is(":checked")) {
        $(".cree_le").show();
      } else {
        $(".cree_le").hide();
      }

      if ($("#filterrific_cree_par").is(":checked")) {
        $(".cree_par").show();
      } else {
        $(".cree_par").hide();
      }

      if ($("#filterrific_soumis_le").is(":checked")) {
        $(".soumis_le").show();
      } else {
        $(".soumis_le").hide();
      }

      if ($("#filterrific_soumis_par").is(":checked")) {
        $(".soumis_par").show();
      } else {
        $(".soumis_par").hide();
      }
      if ($("#filterrific_valide_le").is(":checked")) {
        $(".valide_le").show();
      } else {
        $(".valide_le").hide();
      }
      if ($("#filterrific_valide_par").is(":checked")) {
        $(".valide_par").show();
      } else {
        $(".valide_par").hide();
      }
    }
  }

  iniFla() {
    let fields = document.querySelectorAll(".flatpickr");

    for (let j = 0; j < fields.length; j++) {
      fields[j].classList.add("fx-input-date-sidbar-menu");
    }
  }
  initZindex() {
    let index = [
      ...document.querySelectorAll("#mySidebar DIV"),
      ...document.querySelectorAll("#mySidebar INPUT"),
      ...document.querySelectorAll("#mySidebar I"),
      ...document.querySelectorAll("#mySidebar SPAN"),
      ...document.querySelectorAll("#mySidebar A"),
    ];

    for (let j = 0; j < index.length; j++) {
      index[j].style.zIndex = 100;
    }
  }
  note_de_frais_hm_ajax() {
    console.log(this.current_app);
    if (this.current_app && this.note_de_frai_id) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/note_de_frais/show_ajax_for_hm?note_de_frai_id=" +
        this.note_de_frai_id +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#partial-content").html("");
          $("#partial-content").html(text);
        })
      );
    }
  }
  get current_app() {
    return this.data.get("app");
  }
  get note_de_frai_id() {
    return this.data.get("note_de_fraiid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}
